import { GenericPaginatedListResponse, GenericResponse } from './main'
import { MBTI } from './mbti'
import { Gender } from './user'

/* 음양오행 요소(나무, 불, 땅, 쇠, 물) */
export enum SajuElement {
  WOOD = 'wood',
  FIRE = 'fire',
  EARTH = 'earth',
  METAL = 'metal',
  WATER = 'water',
}

/* 간지 (천간, 지지) */
export type SexagenaryCycle = {
  name: string
  element: SajuElement
}

/* 사주 결과 음양오행 퍼센트 결과*/
export type SajuResultElement = {
  [key in SajuElement]: {
    percentage: number
  }
}

/* 시주, 일주, 월주, 년주 공통 타입 */
export type Pillar = {
  heavenlyStem: SexagenaryCycle
  earthlyBranch: SexagenaryCycle
}

/* 만세력 */
export type Saju = {
  yearPillar: Pillar
  monthPillar: Pillar
  dayPillar: Pillar
  hourPillar: Pillar
}

/* 내 사주 가져오기 */
export type SajuResult = {
  id: number
  name: string
  birthDate: string
  birthTime: string | null
  character: {
    imageUrl: string
    characterImageUrl: string
    name: string
  }
  saju: Saju
  elements: SajuResultElement
  isLunar: boolean
  gender: 'female' | 'male'
  city?: CityItem
}

export enum SajuTestStatus {
  READY = 'READY',
  COMING_SOON = 'COMING_SOON',
  OPEN = 'OPEN',
  UPDATE_REQUIRED = 'UPDATE_REQUIRED',
  RESULT = 'RESULT',
}

export type SajuTestItem = {
  id: number
  title: string
  description: string
  status: SajuTestStatus //TODO: 논의 필요
  imageUrl: string
  ticker?: string
  moveTo?: string
}

export type SajuSurveyItem = {
  id: number
  title: string
  description: string
  isVoted: boolean
}

export type SajuFriendCard = {
  id: number
  name: string
  imageUrl: string
  mainElement: SajuElement
  sajuChemiId?: number
}

export type CityItem = {
  id: number
  name: string
}

/* 색 정책 나오면 수정 */
export const SajuElementColors: {
  [key in SajuElement]: { barColor: string; textColor: string; backgroundColor: string }
} = {
  wood: { barColor: '#3D8779', textColor: '#3D8779', backgroundColor: '#92B5AF' },
  fire: { barColor: '#D06868', textColor: '#D06868', backgroundColor: '#EBB6B6' },
  earth: { barColor: '#E7BA63', textColor: '#E7BA63', backgroundColor: '#F5D28E' },
  metal: { barColor: '#81859E', textColor: '#81859E', backgroundColor: 'var(--grey-95)' },
  water: { barColor: '#28313D', textColor: '#28313D', backgroundColor: '#91969D' },
}

export const SajuElementName: { [key in SajuElement]: string } = {
  wood: 'saju.result.elements.wood',
  fire: 'saju.result.elements.fire',
  earth: 'saju.result.elements.earth',
  metal: 'saju.result.elements.metal',
  water: 'saju.result.elements.water',
}

export const SajuIcon: { [key in SajuElement]: string } = {
  wood: 'fa-tree-deciduous',
  fire: 'fa-fire',
  earth: 'fa-planet-ringed',
  metal: 'fa-gem',
  water: 'fa-water',
}

export type SajuMeta = {
  isProfileCreateFree: boolean
  dohwasalTotalCount: number
  dayPillarAnalysisTotalCount: number
}

export type SajuCreateRequestBody = {
  name: string
  year: number
  month: number
  day: number
  time: string | null
  gender: Gender
  cityId: number | null
  isLunar: boolean
  userIdentifier?: string
}

export type SajuCreateResponse = GenericResponse & {
  data: SajuResult
}

export type SajuResultResponse = GenericResponse & {
  data: SajuResult | {}
}

export type SajuTestListResponse = GenericResponse & {
  data: { tests: SajuTestItem[] }
}

export type SajuSurveyListResponse = GenericResponse & {
  data: { surveys: SajuSurveyItem[] }
}

export type SajuFriendCardPaginatedListResponse = GenericPaginatedListResponse & {
  data: { friendCards: SajuFriendCard[] }
}

export type SearchCityPaginatedResponse = GenericPaginatedListResponse & {
  data: { cities: CityItem[] }
}

export type SajuMetaResponse = GenericResponse & {
  data: SajuMeta
}

export type DohwaPillarHeavenlyStem = 'upgrade'
export type DohwaPillarEarthlyBranch = 'dohwasal' | 'jin'
export type DohwaPillar = {
  heavenlyStem: DohwaPillarHeavenlyStem[]
  earthlyBranch: DohwaPillarEarthlyBranch[]
}

export type DohwaType = 'ug' | 'mm' | 'js' | 'oh' | 'jin' | 'none'
export type DohwaTypeItem = {
  type: DohwaType
  percentage: number | null
  count: number | null
}
export type DohwaResult = {
  types: DohwaTypeItem[]
  ranking: number
  properties: {
    yearPillar: DohwaPillar
    monthPillar: DohwaPillar
    dayPillar: DohwaPillar
    hourPillar: DohwaPillar
  }
  warningDescriptions: string[]
}
export type DohwaResultResponse = GenericResponse & {
  data: { dohwasal: DohwaResult | null }
}

export type CelebrityItem = {
  name: string
  imageUrl: string
}

export type DohwaCard = {
  keywords: string[]
  title: string
  descriptions: string[]
  celebrities: CelebrityItem[]
}

export type DohwaCardResponse = GenericResponse & {
  data: DohwaCard
}

export type SajuListItem = {
  id: number
  name: string
  birthDate: string
  birthTime: string | null
  character: {
    imageUrl: string
    characterImageUrl: string
    name: string
  }
  createdAt: string
  isMain: boolean
}

export type SajuListResponse = GenericResponse & {
  data: {
    profiles: SajuListItem[]
  }
}

export type DohwaName = '유금 도화' | '묘묙 도화' | '자수 도화' | '오화 도화' | '진 도화' | '도화 없도화'

export type DohwaTypeDataItem = {
  color: string
  textColor: string
  duplicateCountColor: string | undefined
  cardImageUrl: string
  gradientColor: string[]
}

export const DohwaTypeData: {
  [key in DohwaType]: DohwaTypeDataItem
} = {
  ug: {
    color: '#99AAB5',
    textColor: '#99AAB5',
    duplicateCountColor: '#99AAB5',
    cardImageUrl: 'assets/icons/saju/dohwa/card-ugeum-dohwa.png',
    gradientColor: ['#99AAB5', 'rgba(153, 170, 181, 0.86)', 'rgba(153, 170, 181, 0.00)'],
  },
  mm: {
    color: '#3D8779',
    textColor: 'var(--white)',
    duplicateCountColor: '#22B186',
    cardImageUrl: 'assets/icons/saju/dohwa/card-myomock-dohwa.png',
    gradientColor: ['#43887A', 'rgba(75, 153, 137, 0.86)', 'rgba(123, 255, 228, 0.00)'],
  },
  js: {
    color: '#434D79',
    textColor: 'var(--white)',
    duplicateCountColor: '#3B3C49',
    cardImageUrl: 'assets/icons/saju/dohwa/card-jasu-dohwa.png',
    gradientColor: ['#454C56', 'rgba(69, 76, 86, 0.86)', 'rgba(69, 76, 86, 0.00)'],
  },
  oh: {
    color: '#E68A8A',
    textColor: 'var(--white)',
    duplicateCountColor: '#B16161',
    cardImageUrl: 'assets/icons/saju/dohwa/card-ohhwa-dohwa.png',
    gradientColor: ['#E68A8A', '#E68A8A', 'rgba(255, 152, 152, 0.00)'],
  },
  jin: {
    color: '#FFB39B',
    textColor: 'var(--white)',
    duplicateCountColor: undefined,
    cardImageUrl: 'assets/icons/saju/dohwa/card-jin-dohwa.png',
    gradientColor: ['#FFC187', '#FFC187', 'rgba(255, 218, 183, 0.00)'],
  },
  none: {
    textColor: 'var(--white)',
    color: 'var(--blue-signal-100)',
    duplicateCountColor: undefined,
    cardImageUrl: 'assets/icons/saju/dohwa/card-no-dohwa.png',
    gradientColor: ['rgba(141, 201, 255, 1)', 'rgba(141, 201, 255, 0.86)', ' rgba(0, 134, 255, 0.00)'],
  },
}

export type DayPillarBaseContent = {
  title: string
  descriptions: string[]
}
export type DayPillarContentSet = {
  title: string
  contents: DayPillarBaseContent[]
}
export type DayPillarAnalysisResult = {
  imageUrl: string
  dayPillar: string
  gender: Gender
  mbti: MBTI // 원래 MBTI
  createdAt: string
  result: {
    dayPillarResult: {
      dayPillarCharacteristics: DayPillarBaseContent
      personalityTraitsReasons: DayPillarContentSet
      behavioralPattern: DayPillarContentSet
      jobsAndReasons: DayPillarContentSet
      fortuneByAge: DayPillarBaseContent
      sajuMatchAndAvoid: DayPillarContentSet
      chemiPerson: DayPillarContentSet
    }
    mbtiResult: {
      mbti: MBTI // 사주로 본 MBTI
      mbtiReasons: string[]
      result: DayPillarContentSet[]
    }
  }
}

export type DayPillarAnalysisResultResponse = GenericResponse & {
  data: DayPillarAnalysisResult
}
